import React, { memo } from 'react';
import { TouchableOpacity, type TouchableOpacityProps } from 'react-native';

// ─────────────────────────────────────────────────────────────────────────────

export const IngredientListItemPressable = memo((props: TouchableOpacityProps) => {
  const { children, ...restProps } = props;

  return (
    <TouchableOpacity accessibilityRole="button" {...restProps}>
      {children}
    </TouchableOpacity>
  );
});
